module.exports = __webpack_public_path__ + "img/floodfighting-20160720-05-1024x768.2da75800.jpg";